import { CbhIcon, Text } from "@clipboard-health/ui-components";
import { useTheme } from "@mui/material";
import { type TierType } from "@src/appV2/redesign/Tiers/api/schema";
import { BasePerk } from "@src/appV2/redesign/Tiers/PerksSection/BasePerk";
import { BasePerksSection } from "@src/appV2/redesign/Tiers/PerksSection/BasePerksSection";
import { getTextColorForTier } from "@src/appV2/redesign/Tiers/utils/getTextColorForTier";

interface SilverPerksSectionProps {
  workerTier: TierType;
}

export function SilverPerksSection(props: SilverPerksSectionProps) {
  const { workerTier } = props;
  const theme = useTheme();
  const matchesWorkerTier = workerTier === "SILVER";
  const workerIsLimited = workerTier === "LIMITED";

  return (
    <BasePerksSection
      headerText={
        <Text semibold variant="h4" color={getTextColorForTier("SILVER", theme)}>
          Silver
        </Text>
      }
      icon={
        <CbhIcon
          type={workerIsLimited ? "locked-filled" : "membership-silver-colored"}
          size="large"
          sx={(theme) => ({
            transform: "scale(1.2)",
            ...(workerIsLimited && { color: theme.palette.tiers?.silver.dark }),
          })}
        />
      }
      perks={[
        <BasePerk
          key="marketplace-access"
          illustration={workerIsLimited ? "tiers-green-lock" : "check-circle-with-diamond"}
          title="Unlimited shift access"
          description="Browse and book from Clipboard's entire shift marketplace"
        />,
      ]}
      matchesWorkerTier={matchesWorkerTier}
    />
  );
}
